<div class="pt-3">
  <p-checkbox
    inputId="betterError"
    [(ngModel)]="betterError"
    [binary]="true"
    (ngModelChange)="betterErrorChange($event)" />
  <label class="ml-3" for="betterError">enable good errors</label>

  @if (env === 'qa' || env === 'dev' || env === 'local' || (env === 'staging' && isSysadmin())) {
    <form (ngSubmit)="changeUser()" class="login-form">
      <div class="form-section">
        <div>
          <label for="username">Username:</label>
        </div>
        <input type="text" pInputText [(ngModel)]="username" id="username" name="username" />
      </div>
      <div class="form-section">
        <button class="signin-button" pButton type="submit">Sign In</button>
      </div>
    </form>
  }
</div>
